import {createUseStyles} from 'react-jss';

export default createUseStyles({
  pudoSavedAddressText: {
    display: 'inline-block',
    width: '90%',
    paddingLeft: props => props.paddingLeft && 8,
    textTransform: 'capitalize',
  },
  fullName: props => ({
    marginBottom: '0.25em',
    fontWeight: props.theme.core.boldFontWeight,
  }),
  address: {
    position: 'relative',
    whiteSpace: 'pre-line',
    textTransform: 'capitalize',
  },
  contactNumber: {
    display: 'flex',
    alignItems: 'center',
    color: 'currentcolor',
    marginTop: '0.33em',
  },
  phoneIcon: {
    width: '0.9em',
    height: '0.9em',
    marginRight: '0.3em',
    fill: 'currentcolor',
  },
});
